/* eslint-disable */
// @ts-nocheck

import React from 'react';

import Box from './Box';

import { FlexProps } from './types';

const Flex: React.FC<FlexProps> = (props) => <Box display="flex" flexWrap="wrap" {...props} />;

export default Flex;
